import React from "react";
import { fechaMX } from "@/lib/format";

const LOGO = "/logo-cooper.png";

// Encabezado corporativo oficial (3 columnas). Por defecto solo aparece al imprimir;
// con `screen` también se muestra en pantalla.
export const PrintHeader = ({ title, folio, fecha, screen = false }) => (
  <div className={`${screen ? "block" : "hidden print:block"} mb-6`}>
    <div className="grid grid-cols-[auto_1fr_auto] gap-6 items-start bg-gray-50 px-3 py-3">
      <div className="text-center">
        <img src={LOGO} alt="Cooper Slip" className="h-16 w-16 object-contain rounded-lg mx-auto" />
        <div className="text-xs mt-1">Cooper Slip</div>
      </div>
      <div className="text-center text-sm font-bold leading-snug pt-3">
        <p>Cuando tu cliente queda bien, Tu quedas mejor.</p>
        <p>Elije las duelas que respaldan a tu negocio</p>
      </div>
      <div className="text-right">
        <h2 className="text-3xl font-extrabold tracking-tight uppercase">{title}</h2>
        {folio && <p className="text-sm mt-1"><span className="font-bold">No.:</span> {folio}</p>}
        <p className="text-sm"><span className="font-bold">Fecha:</span> {fecha || fechaMX(new Date())}</p>
      </div>
    </div>
    <div className="border-t-4 border-black" />
  </div>
);

// Pie corporativo consistente con los documentos oficiales.
export const PrintFooter = ({ screen = false }) => (
  <div className={`${screen ? "block" : "hidden print:block"} border-t border-gray-300 mt-8 pt-3 text-center text-xs text-gray-500`}>
    Duelas Cooper Slip · Naucalpan, Estado de México
  </div>
);
